import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ApiError, httpClient } from '@/api/http-client'

export type PostponePreProgrammedDealInput = {
  dealKey: string
  reason: string
}

export async function postponePreProgrammedDeal({
  dealKey,
  reason,
}: PostponePreProgrammedDealInput) {
  const response = await httpClient('accounting-dealer').put<void>(
    `/v3/deal/${dealKey}/pre-programmed/postpone`,
    { reason },
    { ignoreErrorToast: true },
  )

  return response.data
}

export function usePostponePreProgrammedDeal(
  options?: UseMutationOptions<
    unknown,
    ApiError,
    PostponePreProgrammedDealInput,
    unknown
  >,
) {
  return useMutation({
    mutationFn: postponePreProgrammedDeal,
    ...options,
  })
}
